/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Připraveno`
};

const da_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Klargjort`
};

const de_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Vorbereitet`
};

const en_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Prepared`
};

const es_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Preparado`
};

const fr_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Préparée`
};

const hu_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Felkészítve`
};

const it_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Preparato`
};

const nl_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Voorbereid`
};

const pl_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Przygotowano`
};

const pt_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Preparado`
};

const sv_order_steps_prepared = /** @type {(inputs: {}) => string} */ () => {
	return `Förberedd`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_steps_prepared = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_steps_prepared(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_steps_prepared", locale)
	if (locale === "cs") return cs_order_steps_prepared(inputs)
	if (locale === "da") return da_order_steps_prepared(inputs)
	if (locale === "de") return de_order_steps_prepared(inputs)
	if (locale === "en") return en_order_steps_prepared(inputs)
	if (locale === "es") return es_order_steps_prepared(inputs)
	if (locale === "fr") return fr_order_steps_prepared(inputs)
	if (locale === "hu") return hu_order_steps_prepared(inputs)
	if (locale === "it") return it_order_steps_prepared(inputs)
	if (locale === "nl") return nl_order_steps_prepared(inputs)
	if (locale === "pl") return pl_order_steps_prepared(inputs)
	if (locale === "pt") return pt_order_steps_prepared(inputs)
	return sv_order_steps_prepared(inputs)
};
export { order_steps_prepared as "order_steps.prepared" }